module.exports = __webpack_public_path__ + "images/downloadFile-90e17e7263513e72a3345796f42cb462.svg";